import { cn } from "@/lib/utils";

interface StepProgressProps {
  currentStep: number;   // 1-based display step within the current path
  totalSteps: number;
  stepLabel: string;
}

export function StepProgress({ currentStep, totalSteps, stepLabel }: StepProgressProps) {
  const progress = (currentStep / totalSteps) * 100;

  return (
    <div className="w-full space-y-4" data-testid="step-progress">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          {Array.from({ length: totalSteps }, (_, i) => i + 1).map((step) => (
            <div
              key={step}
              className={cn(
                "w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium transition-all",
                step < currentStep
                  ? "bg-teal-700 text-white"
                  : step === currentStep
                  ? "bg-teal-700 text-white ring-4 ring-teal-700/20"
                  : "bg-gray-200 text-gray-500 dark:bg-gray-700 dark:text-gray-400"
              )}
              data-testid={`progress-step-${step}`}
            >
              {step}
            </div>
          ))}
        </div>
        <span className="text-sm text-muted-foreground font-medium">
          Step {currentStep} of {totalSteps}
        </span>
      </div>

      <div className="space-y-1">
        <div className="h-2 bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden">
          <div
            className="h-full bg-teal-700 transition-all duration-300"
            style={{ width: `${progress}%` }}
            data-testid="progress-bar"
          />
        </div>
        {stepLabel && (
          <p className="text-sm text-muted-foreground">{stepLabel}</p>
        )}
      </div>
    </div>
  );
}
